import React from 'react';
import { DiagonalArrowIcon } from './icons/DiagonalArrowIcon';
import greenBg from '../assets/green_bg.png';
import FunnelFooterWithLinks from './FunnelFooterWithLinks';
import useFunnelNavigation from '../hooks/useFunnelNavigation';
import { getBrand } from '../utils/getBrand';

const GetStartedSection = ({
  showGetStarted = true,
  firstButtonText = null,
  showJustAllRightsReserved = false,
  modifiers = /** @type {{ background?: string, textStyle?: string, iconColor?: string }} */ ({}),
}) => {
  const { navigateToQuiz, navigateToCheckout } = useFunnelNavigation();
  const { brandName } = getBrand();
  // Brands without the green artwork pass a CSS background instead.
  const { background, textStyle = 'text-white', iconColor = 'white' } = modifiers;

  return (
    <section className="relative" style={background ? { background } : undefined}>
      {!background && <img src={greenBg} alt="" className="absolute inset-0 w-full h-full object-cover" />}
      <div
        className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4 ${showJustAllRightsReserved ? 'pt-4 md:pt-28 md:pb-12' : 'pt-24'}`}
      >
        {showGetStarted && (
          <>
            {/* Desktop version */}
            <div className={`hidden md:flex flex-col items-center ${textStyle} mb-16`}>
              <h2 className="flex items-center gap-4 text-[40px] md:text-[56px] leading-[44px] md:leading-[64px] font-semibold font-public-sans">
                Get Started
                <DiagonalArrowIcon className="hidden md:block w-10 max-w-[36px]" color={iconColor} />
              </h2>
              <div className="mt-8 flex flex-col md:flex-row gap-4">
                <button
                  onClick={() => navigateToQuiz(1)}
                  className="bg-black text-white flex justify-center items-center gap-[10px] px-6 py-4 rounded-[100px] font-semibold transition-colors w-full sm:w-auto hover:bg-opacity-90"
                >
                  {firstButtonText || 'Get my job matches now'}
                </button>
                <button
                  onClick={() => navigateToCheckout()}
                  className="flex justify-center bg-[#EBEBEB] text-black items-center gap-[10px] px-6 py-4 rounded-[100px] font-semibold transition-all duration-300 ease-in-out w-full sm:w-auto min-w-[180px] hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Get started with {brandName}
                </button>
              </div>
            </div>

            {/* Mobile version */}
            <div className={`md:hidden flex flex-col items-center ${textStyle} mb-16`}>
              <DiagonalArrowIcon className="block md:hidden mb-2 w-9 max-w-[36px]" color={iconColor} />
              <h2 className="flex items-center gap-4 text-[40px] md:text-[56px] leading-[44px] md:leading-[64px] font-semibold font-public-sans">
                Get Started
              </h2>
              <div className="mt-8">
                <button
                  onClick={() => navigateToQuiz(1)}
                  className="bg-black text-white flex justify-center items-center gap-[10px] px-6 py-4 rounded-[100px] font-semibold transition-colors w-full sm:w-auto hover:bg-opacity-90"
                >
                  Get my job matches now
                </button>
                <button
                  onClick={() => navigateToCheckout()}
                  className="mt-4 md:mt-0 flex justify-center bg-[#EBEBEB] text-black items-center gap-[10px] px-6 py-4 rounded-[100px] font-semibold transition-all duration-300 ease-in-out w-full sm:w-auto min-w-[180px] text-black hover:bg-[#1A1A1A] disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Get started with {brandName}
                </button>
              </div>
            </div>
          </>
        )}
        <FunnelFooterWithLinks showJustAllRightsReserved={showJustAllRightsReserved} />
      </div>
    </section>
  );
};

export default GetStartedSection;
